import { useTranslations } from "providers";

interface HttpErrorProps {
  errorCode?: number | string;
  hideBackHome?: boolean;
}

export const ErrorCode: React.FC<HttpErrorProps> = ({ errorCode, hideBackHome = false }) => {
  const i18n = useTranslations();

  const getErrorMessage = (errorCode: number): string => {
    switch (errorCode) {
      case 400: {
        return i18n.ErrorCodes_BadRequest;
      }
      case 401: {
        return i18n.ErrorCodes_Unauthorized;
      }
      case 403: {
        return i18n.ErrorCodes_Unauthorized;
      }
      case 404: {
        return i18n.ErrorCodes_NotFound;
      }
      case 502: {
        return i18n.ErrorCodes_NoResponse;
      }
      default: {
        return i18n.ErrorCodes_InternalServerError;
      }
    }
  };

  const errorCodeNumber = parseInt(`${errorCode}`, 10);
  const errorMessage = getErrorMessage(errorCodeNumber);

  return (
    <div className="card">
      <div className="card-body">
        <h5 className="card-title">{status}</h5>
        <p>{errorMessage}</p>
        {!hideBackHome && <a href="/">{i18n.BackHome}</a>}
      </div>
    </div>
  );
};
